// @flow
import React from 'react';
import type {Node} from 'react';
import {CourseStatuses} from '../../redux/actions/action-types.js';
import Page from '../../containers/page/page.js';
import {Link} from 'react-router-dom';
import type {StatusType, CourseType, TranslateType} from '../../types.js';
import {Loading} from '../';
import styles from './Courses.module.css';
import translate from '../../config/text';
import defaultPicture from './assets/default.jpg'
import axios from "axios";
import md5 from 'md5'
import {mailChimp} from "../../utility/apiVar";
//
//
// // Utility to assist in decoding a packed JSON variable.
// function read_base64_json(varName) {
//     try {
//         return JSON.parse(new Buffer(process.env[varName], 'base64').toString());
//     } catch (err) {
//         throw new Error(`no ${varName} environment variable`);
//     }
// };
//
// // A simple variable.
// let projectId = process.env.PLATFORM_PROJECT;
// console.log(projectId);
//
// // A JSON-encoded value.
// let variables = read_base64_json('PLATFORM_VARIABLES');
// console.log(variables);
//

type CourseButtonType = {
  title: string,
  url: string,
  id: string,
  status: string,
  onClick: () => void,
  t: TranslateType,
};


export const CourseButton = ({
  title,
  url,
  id,
  status,
  onClick,
  t,
}: CourseButtonType): Node => {
  // TODO: sucks, should have a HOF to encapsulate this issue
  // only add onClick if course hasn't been started
  return (
    status !== CourseStatuses.NOT_STARTED
      ? <Link className={styles.link} to={`/course/${id}`}>
          <CourseLayout {...{title, url, status, t}} />
        </Link>
      : <Link
          className={styles.link}
          to={`/course/${id}`}
          onClick={onClick}
        >
        <CourseLayout {...{title, url, status, t}} />
      </Link>
  );
};

type CourseLayoutType = {
  title: string,
  url: string,
  status: string,
  t: TranslateType,
    progress: {
        total: number,
        complete: number,
    },
};


const CourseLayout = (props: CourseLayoutType, complete: number, total: number): Node => (
  <div className={styles.course}>
    <div
      className={styles.image}
      style={{backgroundImage: `url(${props.url ? props.url : defaultPicture}`}}>
    </div>
      <div className={styles.courseContentParent}>
          {
              props.status !== CourseStatuses.COMPLETED
                  ? <button className={`${styles.contButton} ${styles.coursesBtn} fontBrown`}>{props.t('takeCourse')}</button>
                  : <button className={`${styles.contButton} ${styles.coursesBtn} fontBrown`}>{props.t('courseComplete')}</button>
          }
          <div className={styles.courseContentParent}>
              <div className={styles.courseContent}>
                  <h2 className={'fontBrown'}>{props.title}</h2>
              </div>
          </div>
      </div>
  </div>
);

type CourseListType = {
  courses: CourseType,
  coursesStatuses: {
    [id: string]: StatusType,
  },
  onClick: (string, string) => void,
  t: TranslateType,
};


const CourseList = ({
  courses,
  coursesStatuses,
  onClick,
  t,
}: CourseListType): Array<Node> => {



  return (
    Object.keys(courses).map((key: string, index: number): Node =>
    <CourseButton
    key={index}
    title={courses[key].title[0].value ? courses[key].title[0].value : null}
    id={courses[key].nid[0].value}
    url={courses[key].field_image.length > 0 ? courses[key].field_image[0].url : null}
    status={
      coursesStatuses[key]
      ? coursesStatuses[key]
      : coursesStatuses[key] = CourseStatuses.NOT_STARTED
    }
    onClick={(): void => onClick(
      CourseStatuses.STARTED, courses[key].nid[0].value
    )}
    t={t} />
    )
  );
};


type CoursesType = {
  coursesStatuses: {
    [id: string]: StatusType,
  },
  onClick: () => void,
  resources: {
    data: {
      courses: CourseType,
    },
    loaded: boolean,
  },
  language: string,
};

// coursesStatuses is mapped from state by the CoursesContainer
// gets the latest version
export const Courses = ({
  coursesStatuses,
  onClick,
  resources,
  language,
  email,
  firstName,
  lastName,
  country,
  company,
}: CoursesType): Node => {

  if (!resources.loaded) {
    return <Loading text={'Loading courses'} />;
  }
  const t = translate(language);

    let emailHashed = md5(email);

    const newMember = () => {

  }
    // https://cors-anywhere.herokuapp.com/

  const config = {
      method: 'GET',
      url: `https://cors-anywhere.herokuapp.com/https://us8.api.mailchimp.com/3.0/lists/${mailChimp.listId}/members/${emailHashed}`,
      responseType: 'json',
      headers: {
          'Access-Control-Allow-Origin': 'learn.cambridgeaudio.com',
          'Content-Type': 'application/json',
      },
      auth: {
          password: mailChimp.pass
      }
  }

    axios(config)
        .then(function (response) {
            console.log(response)
        }).catch(function (error) {
        console.log('new member')
        let data = {
            email_address: email,
            status: 'subscribed',
            merge_fields: {
                EMAIL: email,
                FNAME: firstName,
                LNAME: lastName,
                RETAILER: company,
                COUNTRY: country
            }
        }

        axios({
            method: 'POST',
            url: `https://cors-anywhere.herokuapp.com/https://us8.api.mailchimp.com/3.0/lists/${mailChimp.listId}/members`,
            auth: {
                password: mailChimp.pass
            },
            data: JSON.stringify(data)
        });

    });


  return (
    <Page>
        <div
            className={styles.coursesPresentation}>
            <p className={`${styles.welcomeText} fontTisa`}>{t('courses')}</p>
            {/*<p className={`${styles.presentationText} fontTisa`}>{t('clickOnTheLink')}</p>*/}
        </div>
      <div className={styles.coursesContainer}>
        <CourseList
          className={styles.courseElement}
          courses={resources.data.courses}
          coursesStatuses={coursesStatuses}
          onClick={onClick}
          t={t} />
      </div>
    </Page>
  );
};




// WEBPACK FOOTER //
// ./src/components/Courses/Courses.js